function CounterChilds(elemID) {
    const elem = document.querySelector(elemID);

    if (elem) return elem.childNodes[1].childNodes[1].children.length;
}

export default CounterChilds;